import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from "@angular/common/http";
import {
  TuiRootModule,
  TuiDialogModule,
  TuiAlertModule,
  TUI_SANITIZER,
  TuiNotificationsModule,
  TuiLoaderModule,
  TuiButtonModule,
  TuiPrimitiveTextfieldModule,
} from "@taiga-ui/core";
import { TuiInputNumberModule, TuiTabsModule } from "@taiga-ui/kit";

import { Injectable, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgDompurifySanitizer } from "@tinkoff/ng-dompurify";
import { ChartsModule } from "ng2-charts";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomepageComponent } from "./components/homepage/homepage.component";
import { LayoutModule } from "./components/layout/layout.module";
import { ReportsComponent } from "./components/reports/reports.component";
import { AlertComponent } from "./components/shared/alert/alert.component";
import { MultiselectComponent } from "./components/shared/multiselect/multiselect.component";
import { SelectComponent } from "./components/shared/select/select.component";
import { VirtueAlertModalComponent } from "./components/shared/virtuealert/virtuealert.component";
import { VirtueprivacyComponent } from "./components/virtueprivacy/virtueprivacy.component";
import { InputCurrencyPipe } from "./pipe/input-currency.pipe";
import { SafePipe } from "./pipe/safe-html.pipe";
import { PdfViewerModule } from "ng2-pdf-viewer";
// import {  AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ServiceWorkerModule } from "@angular/service-worker";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { environment } from "../environments/environment";
import { HomeContainerComponent } from "./components/home-container/home-container.component";
import { VirtuinputboxComponent } from "./components/shared/virtuinputbox/virtuinputbox.component";
import { VirtuNumber } from "./components/shared/virtunumber/VirtuNumber";
import { StepperContainerComponent } from "./components/stepper-container/stepper-container.component";
import { AppStepperUiComponent } from "./components/stepper/app-stepper";
import { StepperComponent } from "./components/stepper/stepper.component";
import { HttpInterceptorImpl } from "./core/http-Interceptor/HttpInterceptorImpl";
import { AuthGuard } from "./guard/auth.guard";
import { FirstLatterCapitalPipe } from "./pipe/first-capital.pipe";
import { TruncatePipe } from "./pipe/truncate.pipe";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgxTippyModule } from "ngx-tippy-wrapper";
import { VirtueFormModule } from "virtue-form";
import { ComparecollegesComponent } from "./components/comparecolleges/comparecolleges.component";
import { ResultComponent } from "./components/result/result.component";
import { AccordionComponent } from "./components/shared/accordion/accordion.component";
import { AutocompleteSearchBoxComponent } from "./components/shared/autocomplete-search-box/autocomplete-search-box.component";
import { ChartComponent } from "./components/shared/chart/chart.component";
import { CheckboxoptionComponent } from "./components/shared/checkboxoption/checkboxoption.component";
import { AwardletterpopupComponent } from "./components/shared/dialog/awardletterpopup/awardletterpopup.component";
import { CollegeNameSearchBoxComponent } from "./components/shared/dialog/college-name-search-box/college-name-search-box.component";
import { CollegeprofileComponent } from "./components/shared/dialog/collegeprofile/collegeprofile.component";
import { FeedbackformComponent } from "./components/shared/dialog/feedbackform/feedbackform.component";

import { MailmeComponent } from "./components/shared/dialog/mailme/mailme.component";
import { ProfilePopupComponent } from "./components/shared/dialog/profile-popup/profile-popup.component";
import { SelectoptionComponent } from "./components/shared/selectoption/selectoption.component";
import { TooltippopupComponent } from "./components/shared/tooltippopup/tooltippopup.component";
import { WidgetComponent } from "./components/shared/widget/widget.component";
import { DemoUserIntroComponent } from "./components/shared/dialog/demo-user-intro/demo-user-intro.component";
import { ExtendloginaccountComponent } from "./components/shared/dialog/extendloginaccount/extendloginaccount.component";
import { InterestTop5CollegeSelectionComponent } from "./components/interest-top5-college-selection/interest-top5-college-selection.component";
import { Top5CollegeFiltersComponent } from "./components/shared/dialog/top5-college-filters/top5-college-filters.component";
import { ResidencySelctionOptionsComponent } from "./components/shared/residency-selction-options/residency-selction-options.component";
import { CheckAddRemoveCollegeComponent } from "./components/shared/dialog/check-add-remove-college/check-add-remove-college.component";

import { VfrUploadComponent } from "./components/shared/dialog/vfr-upload/vfr-upload.component";

import { PaymentOptionComponent } from "./components/shared/dialog/payment-option/payment-option.component";

import { UsMapModule } from "./components/shared/US-map/us-map/us-map.module";
import { NgxImgZoomModule } from "ngx-img-zoom";
import { InternationalTop5SelectionComponent } from "./components/international-top5-selection/international-top5-selection.component";
import { InternationalTop5CompareComponent } from "./components/international-top5-compare/international-top5-compare.component";
import { ResultNotepopupComponent } from "./components/shared/dialog/result-notepopup/result-notepopup.component";
import { CollegesCartViewComponent } from "./components/shared/colleges-cart-view/colleges-cart-view.component";
import { CardRowViewComponent } from "./components/shared/card-row-view/card-row-view.component";
import { AntherMapComponent } from './components/shared/dialog/anther-map/anther-map.component';
import { RepocityTooltipComponent } from './components/shared/US-map/repocity-tooltip/repocity-tooltip.component';
import { PaySubscribeComponent } from './components/shared/dialog/pay-subscribe/pay-subscribe.component';
import { MyAccountsComponent } from './components/my-accounts/my-accounts.component';
import { CancelInfoComponent } from './components/shared/dialog/cancel-info/cancel-info.component';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });
    return next.handle(authReq);
  }
}
@NgModule({
  declarations: [
    AutocompleteSearchBoxComponent,
    CollegeNameSearchBoxComponent,
    AppComponent,
    ReportsComponent,
    InputCurrencyPipe,
    FirstLatterCapitalPipe,
    SafePipe,
    AlertComponent,
    SelectComponent,
    VirtueAlertModalComponent,
    MultiselectComponent,
    HomepageComponent,
    VirtueprivacyComponent,
    VirtuinputboxComponent,
    VirtuNumber,
    StepperComponent,
    AppStepperUiComponent,
    HomeContainerComponent,
    StepperContainerComponent,
    TruncatePipe,
    WidgetComponent,
    TooltippopupComponent,
    SelectoptionComponent,
    CheckboxoptionComponent,
    ResultComponent,
    AccordionComponent,
    FeedbackformComponent,
    CollegeprofileComponent,
    ChartComponent,
    ComparecollegesComponent,
    MailmeComponent,
    AwardletterpopupComponent,
    ProfilePopupComponent,
    DemoUserIntroComponent,
    ExtendloginaccountComponent,
    InterestTop5CollegeSelectionComponent,
    Top5CollegeFiltersComponent,
    ResidencySelctionOptionsComponent,
    CheckAddRemoveCollegeComponent,
    VfrUploadComponent,
    PaymentOptionComponent,
    InternationalTop5SelectionComponent,
    InternationalTop5CompareComponent,
    ResultNotepopupComponent,
    CollegesCartViewComponent,
    CardRowViewComponent,
    AntherMapComponent,
    RepocityTooltipComponent,
    PaySubscribeComponent,
    MyAccountsComponent,
    CancelInfoComponent,
  ],
  imports: [
    BrowserModule,
    PdfViewerModule,
    NgxImgZoomModule,
    AppRoutingModule,
    LayoutModule,
    SelectDropDownModule,
    HttpClientModule,
    FormsModule,
    ChartsModule,
    ReactiveFormsModule,
    VirtueFormModule,
    NgxSpinnerModule,
    AutocompleteLibModule,
    CarouselModule.forRoot(),
    BsDropdownModule.forRoot(),
    BrowserAnimationsModule,
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    AccordionModule.forRoot(),
    CollapseModule.forRoot(),
    TypeaheadModule.forRoot(),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    TuiNotificationsModule,
    NgxTippyModule,
    NgMultiSelectDropDownModule.forRoot(),
    TuiRootModule,
    TuiAlertModule,
    TuiInputNumberModule,
    TuiPrimitiveTextfieldModule,
    TuiLoaderModule,
    UsMapModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    NgxSpinnerService,
    AuthGuard,
    TruncatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorImpl,
      multi: true,
    },
    { provide: TUI_SANITIZER, useClass: NgDompurifySanitizer },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
